import * as domain from '../actions/domain.actions';
import { Domain } from 'modules/shared/models/domain.models';
import { AppState } from 'store/root-reducer';
import { createSelector } from '@ngrx/store';
import { DomainActionTypes } from '../actions/domain.actions';
export interface State {
  domains: Domain[];
  currentDomain: Domain;
  errorMessage: string;
  loading: Array<DomainActionTypes>;
}

const initialState: State = {
  domains: [],
  currentDomain: null,
  errorMessage: null,
  loading: []
};

export function reducer(state: State = initialState, action: domain.DomainActions): State {
  switch (action.type) {
    case domain.DomainActionTypes.LOAD_DOMAIN_LIST: {
      return {
        ...state,
        loading: [...state.loading, action.type]
      };
    }
    case domain.DomainActionTypes.LOAD_DOMAIN_LIST_SUCCESS: {
      return {
        ...state,
        domains: action.payload,
        loading: clearLoading(state, DomainActionTypes.LOAD_DOMAIN_LIST),
        errorMessage: null
      };
    }
    case domain.DomainActionTypes.LOAD_DOMAIN_LIST_FAILURE: {
      return {
        ...state,
        loading: clearLoading(state, DomainActionTypes.LOAD_DOMAIN_LIST),
        errorMessage: action.payload
      };
    }
    case domain.DomainActionTypes.CLEAR_LOAD_DOMAIN_LIST: {
      localStorage.setItem('domain', '{ domains: [], currentDomain: null, errorMessage: null }');
      return {
        ...state,
        domains: [],
        currentDomain: null,
        loading: clearLoading(state, DomainActionTypes.LOAD_DOMAIN_LIST),
        errorMessage: null
      };
    }
    case domain.DomainActionTypes.SET_DOMAIN: {
      return {
        ...state,
        currentDomain: action.payload,
        loading: [...state.loading, action.type]
      };
    }
    case domain.DomainActionTypes.CHANGE_DOMAIN: {
      return {
        ...state,
        currentDomain: action.payload,
        loading: [...state.loading, action.type]
      };
    }
    case domain.DomainActionTypes.CREATE_DOMAIN_SUCCESS: {
      return {
        ...state,
        domains: [...state.domains, action.payload],
        loading: clearLoading(state, DomainActionTypes.CREATE_DOMAIN)
      };
    }
    case domain.DomainActionTypes.CREATE_DOMAIN_FAILURE: {
      return {
        ...state,
        errorMessage: action.payload,
        loading: clearLoading(state, DomainActionTypes.CREATE_DOMAIN)
      };
    }
    default: {
      return state;
    }
  }
}

const domainSelector = (state: AppState) => state.domain;
export const Selectors = {
  getDomains: createSelector(domainSelector, (state: State) => state.domains),
  getCurrentDomain: createSelector(domainSelector, (state: State) => state.currentDomain),
  getLoading: createSelector(domainSelector, (state: State) => state.loading)
};

function clearLoading(authState: State, action: DomainActionTypes): Array<DomainActionTypes> {
  return authState.loading.filter((loadingMarker: DomainActionTypes) => loadingMarker !== action);
}
